import moment from 'moment';

import { useModal } from 'Store/modal';
import usePostPresenceClockOut from 'Domain/monitoring/usePostPresenceClockOut';
import { monitoringHookText } from 'Const/monitoring/view';

const useOpenClockOutConfirmation = () => {
  const { onOpenModal, onResetModal } = useModal();
  const { mutate: onPostPresenceClockOut } = usePostPresenceClockOut();

  const getClockOutText = (monitoringStatus) => {
    const { clockOutTitleText, clockOutDescText, clockOutViolationTitleText, getClockOutViolationDescText } = monitoringHookText;

    const endClockOutTime = monitoringStatus?.shift?.endTime;
    const clockInAt = monitoringStatus?.presence?.clockInAt;
    const clockOutViolationDescText = getClockOutViolationDescText(endClockOutTime);

    if (!endClockOutTime) return {};

    const [hour, minute, second] = endClockOutTime?.split(':').map(Number);

    const today = moment();
    const endClockOut = moment(clockInAt).set('hour', hour).set('minute', minute).set('second', second);

    const isViolation = today.isBefore(endClockOut, 'second');

    if (isViolation) return { title: clockOutViolationTitleText, desc: clockOutViolationDescText };

    return { title: clockOutTitleText, desc: clockOutDescText };
  };

  const onSubmitClockOut = ({ monitoringStatus }) => {
    onPostPresenceClockOut({ monitoringStatus });
    onResetModal();
  };

  const onOpenClockOutConfirmationModal = ({ monitoringStatus }) => {
    const texts = getClockOutText(monitoringStatus);

    onOpenModal({
      width: '400px',
      isOpen: true,
      type: 'confirm',
      title: texts.title,
      contentDescription: texts.desc,
      showPrimaryButton: true,
      secondaryButtonText: 'Batal',
      showSecondaryButton: true,
      primaryButtonText: 'Ya, Lanjut',
      onClickPrimaryButton: () => onSubmitClockOut({ monitoringStatus }),
    });
  };

  return onOpenClockOutConfirmationModal;
};

export default useOpenClockOutConfirmation;
